


































































































import {Component, PropSync, Watch} from 'vue-property-decorator'
import {Getter, Action} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {AccountFilter} from "@/store/accounts/types";
import {SelectWings, ToggleWings} from "wings-ui-components";
import {notifyError, notifyWarning} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';

@Component({components: {SelectWings, ToggleWings}})
export default class AccountsFilter extends BaseFilter<AccountFilter>{
  @PropSync('show') is_show!: boolean;
  @PropSync('filterClone') propFilterClone!: any;
  @PropSync('runFilter') propRunFilter!: any;

  @Getter("transports") transportsList: any;
  @Getter("protocolList") protocolList: any;

  @Action("getTransports") actionGetTransports: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("exportAccounts") actionExportAccounts: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): AccountFilter {
    return {
      name: undefined,
      login: undefined,
      protocol: undefined,
      transport: undefined,
      status: undefined,
      page_number: 1,
    }
  }

  loginList: any = []
  nameList: any = []
  statusList: number[] = [1,0];

  filterKeys: object = {
    "name" : "account_name",
    "login" : "account_login",
  }

  async getNameList(filter: any) {
    const items = await this.actionGetAccounts(filter);
    this.nameList = (filter?.page_number > 1) ? this.nameList.concat(items) : items
  }

  async getLoginList(filter: any) {
    const items = await this.actionGetAccounts(filter);
    this.loginList = (filter?.page_number > 1) ? this.loginList.concat(items) : items
  }

  async created() {
    try {
      this.actionGetTransports();
      this.filtered();
      this.scroll();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.name) this.nameList = await this.actionGetAccounts({name: this.filter.name});
    if (this.filter.login) this.loginList = await this.actionGetAccounts({login: this.filter.login});
  }

  async onFilteredAction(nextPage = false) {
    if (!nextPage) this.filter.page_number = 1;
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: "success",
        objectType: "Account",
        addititionalInfo: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetAccounts(this.filter);
      await this.actionLog(this.logObject);
      if (resp?.length == 0) {
        this.is_last = true
        if (!nextPage) notifyWarning()
      } else {
        this.is_last = false
      }
    } catch (err) {
      await this.actionLog({...this.logObject, actionStatus: "failed"});
      notifyError(err);
    } finally {
      this.moreLoading = false;
    }
  }

  export(): void {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Export",
        actionStatus: "success",
        objectType: "Account",
        addititionalInfo: getTranslatedParams(this.filter, this.filterKeys)
      }
      this.actionExportAccounts(this.filter)
      this.actionLog(this.logObject);
    } catch(error) {
      this.actionLog({...this.logObject, actionStatus: "failed"});
      notifyError(error)
    }
  }

  @Watch('filter', {immediate: true, deep: true})
  onFilterChanged(val: AccountFilter) {
    this.propFilterClone = val;
  }

  @Watch('propRunFilter', { immediate: true })
  onRunFilter(val: boolean) {
    if (!val) return;
    this.filtered();
    this.propRunFilter = false;
  }
}
